// extracted by mini-css-extract-plugin
module.exports = {"chartstyles":"BarChart_chartstyles__2Sino"};